<template>
  <div class="app-container">
    <div class="top_btns" style="margin-bottom:0px">
      <div class="">
        <search @success="getList">
          <el-form style="margin:20px 0px 40px 10px;width:400px" class="styleForm">
            <el-form-item label="选择期间：" :label-width="formLabelWidth" >
              <qzf-period v-model:period="listQuery.period"></qzf-period>
            </el-form-item>
            <el-form-item label="会计期间：" :label-width="formLabelWidth">   
              <qzf-period v-model:period="listQuery.beginTime"></qzf-period>
              <span>-</span>
              <qzf-period v-model:period="listQuery.endTime"></qzf-period>
            </el-form-item>
            <el-form-item label="选择级别：" :label-width="formLabelWidth" style="">
              <el-input placeholder="1" style="width: 80px;" class="filter-item" size="mini" :disabled="true" />
              -
              <el-input placeholder="请输入级别" v-model.number="listQuery.level" style="width:80px;" class="filter-item" size="mini" />
            </el-form-item>
          </el-form>
        </search>
      </div>
      <p class="top_p">
        <span>凭证总张数：{{this.counts.count}}张&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;附件总张数：{{this.counts.billCount}}张</span>
      </p>
      <div class="">
        <el-dropdown style="margin-left: 6px;">
          <qzf-button jz="false" button_code="zb_pzhz_gd" type="primary" size="mini">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </qzf-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item><qzf-button jz="false" button_code="zb_pzhz_dya4h" size="mini" @click="printing()" type="success" plain>打印</qzf-button></el-dropdown-item>
              <el-dropdown-item><qzf-button jz="false" button_code="zb_pzhz_dc" size="mini" @click="daochu()" type="info" plain>导出</qzf-button></el-dropdown-item>
            </el-dropdown-menu>
          </template> 
        </el-dropdown>
      </div>
    </div>
    
    <div class="biaotou">
      <span>公司名：{{comName}}</span>
      <span>账期：{{comPeriod}}</span>
      <span>单位：元</span>
    </div>
    <el-table :height="contentStyleObj" :data="seachlist" size="mini" :header-cell-style="{background: '#eee',color:'#333','font-size': '13px'}" v-loading="listLoading" :key="tableKey" border fit highlight-current-row @sort-change="sortChange">
      <el-table-column label="科目编码" align="center" width="240">
        <template #default="scope">
          <span>{{scope.row.subjectCode}}</span>
        </template>
      </el-table-column>
      <el-table-column label="科目名称" align="center" width="240">
        <template #default="scope">
          <span>{{scope.row.subjectName}}</span>
        </template>
      </el-table-column>

      
      <el-table-column label="本期合计" align="center">
        <el-table-column prop="periodInt" label="借" width="320" align="center">
          <template #default="scope">
            <span>{{scope.row.periodInt}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="periodOut" label="贷" width="320" align="center">
          <template #default="scope">
            <span>{{scope.row.periodOut}}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="方向" align="center">
        <template #default="scope">
          <span>{{scope.row.type}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <printVouch ref="printVouch" name="book_all_voucher" :listQuery1="this.listQuery"></printVouch>
    <exportFile ref="exportFile" name="book_all_voucher" :listQuery1="this.listQuery"></exportFile> -->
  </div>
</template>

<script>

import { bookAllVoucherListHis } from "@/api/old.js"
// import printVouch from "./printVouch.vue"
// import exportFile from "./exportFile.vue"
export default {
  // components: {
  //   printVouch,
  //   exportFile
  // },
  data() {
    return {
      formLabelWidth: '100px',
      contentStyleObj:{}, //高度变化
      seachlist: [],
      comName: '',
      comPeriod: this.$store.getters['user/comInfo'].period,
      counts : {
        count:0,
        billCount: 0
      },
      listQuery: {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period:this.$store.getters['user/comInfo'].period,
        beginTime:'',
        endTime:'',
        // subjectCode: '',
        level: 1
      },
    }
  },
  created() {
    // 获取表格高度
    this.contentStyleObj=this.$getHeight(270)
    this.getList()
  },
  methods: {
    // printing() {
    //   this.$refs.printVouch.init()
    // },
    // daochu(){
    //   this.$refs.exportFile.init()
    // },
    getList(){
      bookAllVoucherListHis(this.listQuery).then(res=>{
        this.counts = res.data.data.count
        if(res.data.data.list) {
          this.seachlist = res.data.data.list
        }else {
          this.seachlist = []
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.biaotou{
  line-height: 25px;
  font-size: 14px;
  color: #333;
  width: 100%;
  padding: 5px 0 10px 0;
  span{
    display: inline-block;
    width: 33%;
  }
  span:nth-child(1){
    text-align: left;
  }
  span:nth-child(2){
    text-align: center;
  }
  span:nth-child(3){
    text-align: right;
  }
}
.top_btns {
  display: flex;
  justify-content: space-between;
  .left_box{
    float: left;
    width: 70%;
    height: 50px!important;
  }
  .right_box {
    float: right;
    width: 30%;
    text-align: right;
  }
}
.top_p{
  font-size: 15px;
  color: #333;
  // margin-bottom: 10px;
  margin-top: 2px;
}
</style>